import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "financial-info" }
const _hoisted_2 = {
  key: 0,
  class: "other"
}
const _hoisted_3 = {
  key: 1,
  class: "other"
}
const _hoisted_4 = {
  key: 2,
  class: "other"
}
const _hoisted_5 = {
  key: 3,
  class: "other"
}
const _hoisted_6 = { class: "other" }
const _hoisted_7 = {
  key: 4,
  class: "other"
}
const _hoisted_8 = { class: "first-item" }
const _hoisted_9 = { class: "custom-field-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "derivative"
}
const _hoisted_11 = {
  key: 0,
  class: "other"
}
const _hoisted_12 = {
  key: 1,
  class: "other"
}
const _hoisted_13 = { class: "employment-period" }
const _hoisted_14 = {
  key: 2,
  class: "trade-record-upload"
}
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_custom_picker = _resolveComponent("custom-picker")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_popup = _resolveComponent("popup")!
  const _component_layout = _resolveComponent("layout")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_layout, {
      onHandleNext: _ctx.handleNext,
      current: 1,
      isDisabled: _ctx.isDisabled,
      form: { ..._ctx.form, derivativeCode9: _ctx.derivativeCode9, derivativeCode10: _ctx.derivativeCode10, derivativeCode11: _ctx.derivativeCode11 },
      prePathName: "contact-info"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[77] || (_cache[77] = _createElementVNode("div", { class: "title" }, "财富来源", -1)),
          _cache[78] || (_cache[78] = _createElementVNode("div", { class: "option-title" }, null, -1)),
          _createVNode(_component_van_field, {
            name: "checkboxGroup",
            rules: [{ required: true, message: '请至少选择一项' }],
            class: "checkbox"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_checkbox_group, {
                modelValue: _ctx.form.assetSource,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.assetSource) = $event)),
                class: "checkbox"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetSourceOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_van_checkbox, {
                      key: item.name,
                      name: item.name,
                      shape: "square"
                    }, {
                      icon: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(`iconfont ${
                    _ctx.form.assetSource.includes(item.name)
                      ? 'icon-duoxuanxuanzhong'
                      : 'icon-duoxuanweixuanzhong'
                  }`)
                        }, null, 2)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.form.assetSource.includes(10))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_van_field, {
                  name: "aSother",
                  modelValue: _ctx.form.assetSourceOther,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.assetSourceOther) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "其他请输入",
                  rules: [{ required: true, message: '请输入' }]
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _cache[79] || (_cache[79] = _createElementVNode("div", { class: "title" }, "每年收入（港币）", -1)),
          _createVNode(_component_van_field, {
            name: "income",
            modelValue: _ctx.form.annualIncomeText,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.annualIncomeText) = $event)),
            modelModifiers: { trim: true },
            placeholder: "选择每年收入（港币）",
            "right-icon": "arrow-down",
            readonly: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showIncomePickerToggle(true))),
            rules: [{ required: true, message: '请选择每年收入' }]
          }, null, 8, ["modelValue"]),
          (_ctx.form.annualIncome === 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_van_field, {
                  name: "annualIncomeOther",
                  modelValue: _ctx.form.annualIncomeOther,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.annualIncomeOther) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请注明",
                  rules: [{ required: true, message: '请注明' }]
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_van_popup, {
            show: _ctx.showIncomePicker,
            "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showIncomePicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "请选择",
                "default-index": _ctx.form.annualIncomeIdx,
                columns: _ctx.annualIncomeOptions,
                onConfirm: _ctx.onIncomeConfirm,
                onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showIncomePickerToggle(false)))
              }, null, 8, ["default-index", "columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"]),
          _cache[80] || (_cache[80] = _createElementVNode("div", { class: "title" }, "资产项目", -1)),
          _createVNode(_component_van_field, {
            name: "assetItem",
            class: "checkbox",
            rules: [{ required: true, message: '请至少选择一项' }]
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_checkbox_group, {
                modelValue: _ctx.form.assetItem,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.assetItem) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_van_checkbox, {
                      key: item.name,
                      name: item.name,
                      shape: "square"
                    }, {
                      icon: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(`iconfont ${
                    _ctx.form.assetItem.includes(item.name)
                      ? 'icon-duoxuanxuanzhong'
                      : 'icon-duoxuanweixuanzhong'
                  }`)
                        }, null, 2)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.form.assetItem.includes(5))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_van_field, {
                  name: "aIOther",
                  modelValue: _ctx.form.assetItemOther,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.assetItemOther) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "其他请输入",
                  rules: [{ required: true, message: '请输入' }]
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _cache[81] || (_cache[81] = _createElementVNode("div", { class: "title" }, "资产净值（港币）", -1)),
          _createVNode(_component_van_field, {
            name: "netAsset",
            modelValue: _ctx.form.netAssetText,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.netAssetText) = $event)),
            modelModifiers: { trim: true },
            placeholder: "选择资产净值",
            "right-icon": "arrow-down",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showNetPickerToggle(true))),
            readonly: "",
            rules: [{ required: true, message: '请选择资产净值' }]
          }, null, 8, ["modelValue"]),
          (_ctx.form.netAsset === 7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_van_field, {
                  name: "netAssetOther",
                  modelValue: _ctx.form.netAssetOther,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.netAssetOther) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请注明",
                  rules: [{ required: true, message: '请注明' }]
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_van_popup, {
            show: _ctx.showNetPicker,
            "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showNetPicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "请选择",
                "default-index": _ctx.form.netAssetIdx,
                columns: _ctx.netAssetOptions,
                onConfirm: _ctx.onNetConfirm,
                onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showNetPickerToggle(false)))
              }, null, 8, ["default-index", "columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"]),
          _cache[82] || (_cache[82] = _createElementVNode("div", { class: "title" }, "投资目标", -1)),
          _createVNode(_component_van_field, {
            name: "checkboxGroup",
            rules: [{ required: true, message: '请至少选择一项' }],
            class: "checkbox"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_checkbox_group, {
                modelValue: _ctx.form.investTarget,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.investTarget) = $event)),
                rules: [{ required: true, message: '请选择投资目标' }]
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investTargetOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_van_checkbox, {
                      key: item.name,
                      name: item.name,
                      shape: "square"
                    }, {
                      icon: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(`iconfont ${
                    _ctx.form.investTarget.includes(item.name)
                      ? 'icon-duoxuanxuanzhong'
                      : 'icon-duoxuanweixuanzhong'
                  }`)
                        }, null, 2)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.form.investTarget.includes(5))
              ? (_openBlock(), _createBlock(_component_van_field, {
                  key: 0,
                  name: "iother",
                  modelValue: _ctx.form.investTargetOther,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.investTargetOther) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "其他请输入",
                  rules: [{ required: true, message: '请输入' }]
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _cache[83] || (_cache[83] = _createElementVNode("div", { class: "title" }, "预期每年投资金额", -1)),
          _createVNode(_component_van_field, {
            name: "amount",
            modelValue: _ctx.form.expectedYearInvestmentAmountText,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.expectedYearInvestmentAmountText) = $event)),
            modelModifiers: { trim: true },
            placeholder: "选择金额",
            readonly: "",
            "right-icon": "arrow-down",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showAmountPickerToggle(true))),
            rules: [{ required: true, message: '请选择金额' }]
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.showAmountPicker,
            "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showAmountPicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "请选择",
                "default-index": _ctx.form.expectedYearInvestmentAmountIdx,
                columns: _ctx.amountOptions,
                onConfirm: _ctx.onAmountConfirm,
                onCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showAmountPickerToggle(false)))
              }, null, 8, ["default-index", "columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"]),
          (_ctx.form.expectedYearInvestmentAmount === 7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_van_field, {
                  name: "expectedYearInvestmentAmountOther",
                  modelValue: _ctx.form.expectedYearInvestmentAmountOther,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.expectedYearInvestmentAmountOther) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请注明",
                  rules: [{ required: true, message: '请注明' }]
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _cache[84] || (_cache[84] = _createElementVNode("div", { class: "title" }, "投资经验", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_cell_group, {
              title: "股票",
              border: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_picker, {
                  columns: _ctx.yearOptions,
                  value: _ctx.form.stockInvestmentExperienceType,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.stockInvestmentExperienceType) = $event)),
                  placeholder: "选择年数"
                }, null, 8, ["columns", "value"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_van_cell_group, {
            title: "债券",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.bondInvestmentExperienceType,
                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.bondInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "衍生权证",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.derivativeInvestmentExperienceType,
                "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.derivativeInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "牛熊证",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.bullBearInvestmentExperienceType,
                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.bullBearInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "交易所买卖基金",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.etfInvestmentExperienceType,
                "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.etfInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "杠杆及反向产品",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.leverInvestmentExperienceType,
                "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.leverInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "固定派息票据",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.fcnInvestmentExperienceType,
                "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.fcnInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "股票挂钩票据",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.elnInvestmentExperienceType,
                "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.elnInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "计认购期权/累计认沽期权",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.aqDqInvestmentExperienceType,
                "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.aqDqInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "参与式票据",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.pbInvestmentExperienceType,
                "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.pbInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "区间票据",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.ibInvestmentExperienceType,
                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.ibInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "总收益互换",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.trsInvestmentExperienceType,
                "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.trsInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "雪球派息票据",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.scnInvestmentExperienceType,
                "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.scnInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "场外期权",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.otcOptionInvestmentExperienceType,
                "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.otcOptionInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "单位信托或互惠基金",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.trustFundInvestmentExperienceType,
                "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.trustFundInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell_group, {
            title: "私募基金",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_custom_picker, {
                columns: _ctx.yearOptions,
                value: _ctx.form.privateFundInvestmentExperienceType,
                "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.privateFundInvestmentExperienceType) = $event)),
                placeholder: "选择年数"
              }, null, 8, ["columns", "value"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _cache[65] || (_cache[65] = _createElementVNode("div", { class: "van-cell-group__title custom-label" }, "其他", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.otherInvestment, (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bot-border",
                key: i
              }, [
                _createVNode(_component_van_row, {
                  justify: "space-between",
                  align: "center",
                  gutter: 10
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: v.otherInvestmentName ? 10 : 22
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_field, {
                          name: "otherInvestmentName",
                          modelValue: v.otherInvestmentName,
                          "onUpdate:modelValue": ($event: any) => ((v.otherInvestmentName) = $event),
                          modelModifiers: { trim: true },
                          placeholder: "请输入"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["span"]),
                    (v.otherInvestmentName)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 0,
                          span: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_custom_picker, {
                              class: "custom-picker",
                              columns: _ctx.otherYearOptions,
                              placeholder: "请选择",
                              value: v.otherInvestmentExperienceType,
                              "onUpdate:value": ($event: any) => ((v.otherInvestmentExperienceType) = $event)
                            }, null, 8, ["columns", "value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_component_van_col, {
                      span: "2",
                      style: {"text-align":"center"}
                    }, {
                      default: _withCtx(() => [
                        (i !== 0)
                          ? (_openBlock(), _createBlock(_component_van_icon, {
                              key: 0,
                              name: "cross",
                              onClick: ($event: any) => (_ctx.removeOther(v)),
                              class: "custom-close-icon"
                            }, null, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_van_icon, {
                              key: 1,
                              name: "plus",
                              onClick: _ctx.addOther,
                              class: "custom-close-icon"
                            }, null, 8, ["onClick"]))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _cache[85] || (_cache[85] = _createElementVNode("div", { class: "title" }, "衍生品认知", -1)),
          _cache[86] || (_cache[86] = _createElementVNode("div", { class: "option-title" }, "阁下有意买卖衍生品？", -1)),
          _createVNode(_component_van_field, { name: "isTradeDerivativeProducts" }, {
            input: _withCtx(() => [
              _createVNode(_component_van_radio_group, {
                modelValue: _ctx.form.isTradeDerivativeProducts,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.isTradeDerivativeProducts) = $event)),
                direction: "horizontal"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.derivativeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_van_radio, {
                      key: item.name,
                      name: item.name
                    }, {
                      icon: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "iconfont icon-xuanze1",
                          style: _normalizeStyle({
                    color: _ctx.form.isTradeDerivativeProducts == item.name ? '#FFB400' : '#A5B2DC',
                  })
                        }, null, 4)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _cache[76] || (_cache[76] = _createElementVNode("div", { class: "option-title" }, "阁下有否衍生品之认识？", -1)),
            _createVNode(_component_van_field, { name: "isKnowDerivativeProducts" }, {
              input: _withCtx(() => [
                _createVNode(_component_van_radio_group, {
                  modelValue: _ctx.form.isKnowDerivativeProducts,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.isKnowDerivativeProducts) = $event)),
                  direction: "horizontal"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.derivativeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_van_radio, {
                        key: item.name,
                        name: item.name
                      }, {
                        icon: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "iconfont icon-xuanze1",
                            style: _normalizeStyle({
                      color: _ctx.form.isKnowDerivativeProducts == item.name ? '#FFB400' : '#A5B2DC',
                    })
                          }, null, 4)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(item.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.form.isKnowDerivativeProducts === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_van_field, {
                    name: "isKnowDerivativeProducts",
                    rules: [{ required: true, message: '请至少选择一项' }]
                  }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_checkbox_group, {
                        modelValue: _ctx.form.derivativeCheck,
                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.form.derivativeCheck) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_checkbox, {
                            shape: "square",
                            name: 9
                          }, {
                            icon: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(`iconfont ${
                        _ctx.form.derivativeCheck.includes(9)
                          ? 'icon-duoxuanxuanzhong'
                          : 'icon-duoxuanweixuanzhong'
                      }`)
                              }, null, 2)
                            ]),
                            default: _withCtx(() => [
                              _cache[66] || (_cache[66] = _createTextVNode("阁下曾否接受过有关衍生品的课程或培训"))
                            ]),
                            _: 1
                          }),
                          (_ctx.form.derivativeCheck.includes(9))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_van_field, {
                                  name: "derivativeDetail1",
                                  modelValue: _ctx.derivativeCode9.derivativeDetail1,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.derivativeCode9.derivativeDetail1) = $event)),
                                  modelModifiers: { trim: true },
                                  placeholder: "请注明课程/研讨会名称",
                                  rules: [{ required: true, message: '请注明课程/研讨会名称' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                  name: "derivativeDetail2",
                                  modelValue: _ctx.derivativeCode9.derivativeDetail2,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.derivativeCode9.derivativeDetail2) = $event)),
                                  modelModifiers: { trim: true },
                                  placeholder: "请注明主办机构",
                                  rules: [{ required: true, message: '请注明主办机构' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                  name: "derivativeDetail3",
                                  modelValue: _ctx.derivativeCode9.derivativeDetail3,
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.derivativeCode9.derivativeDetail3) = $event)),
                                  modelModifiers: { trim: true },
                                  readonly: "",
                                  onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.showDatePickerToggle(true))),
                                  placeholder: "请注明参与年份",
                                  rules: [{ required: true, message: '请注明参与年份' }]
                                }, {
                                  "right-icon": _withCtx(() => _cache[67] || (_cache[67] = [
                                    _createElementVNode("i", { class: "iconfont icon-icon--date" }, null, -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_van_popup, {
                                  show: _ctx.showDatePicker,
                                  "onUpdate:show": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.showDatePicker) = $event)),
                                  round: "",
                                  position: "bottom"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_van_datetime_picker, {
                                      type: "year-month",
                                      title: "选择年份",
                                      modelValue: _ctx.currentDate,
                                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.currentDate) = $event)),
                                      formatter: _ctx.formatter,
                                      onCancel: _cache[44] || (_cache[44] = ($event: any) => (_ctx.showDatePickerToggle(false))),
                                      onConfirm: _ctx.onDateConfirm,
                                      "min-date": _ctx.minDate,
                                      "max-date": _ctx.currDate
                                    }, null, 8, ["modelValue", "formatter", "onConfirm", "min-date", "max-date"])
                                  ]),
                                  _: 1
                                }, 8, ["show"])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_van_checkbox, {
                            shape: "square",
                            name: 10
                          }, {
                            icon: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(`iconfont ${
                        _ctx.form.derivativeCheck.includes(10)
                          ? 'icon-duoxuanxuanzhong'
                          : 'icon-duoxuanweixuanzhong'
                      }`)
                              }, null, 2)
                            ]),
                            default: _withCtx(() => [
                              _cache[68] || (_cache[68] = _createTextVNode("阁下是否拥有与衍生品有关的工作经验"))
                            ]),
                            _: 1
                          }),
                          (_ctx.form.derivativeCheck.includes(10))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_van_field, {
                                  name: "derivativeDetail1",
                                  modelValue: _ctx.derivativeCode10.derivativeDetail1,
                                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.derivativeCode10.derivativeDetail1) = $event)),
                                  modelModifiers: { trim: true },
                                  placeholder: "请注明任职公司名称",
                                  rules: [{ required: true, message: '请注明任职公司名称' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                  name: "derivativeDetail4",
                                  modelValue: _ctx.derivativeCode10.derivativeDetail4,
                                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.derivativeCode10.derivativeDetail4) = $event)),
                                  modelModifiers: { trim: true },
                                  placeholder: "请注明部门",
                                  rules: [{ required: true, message: '请注明部门' }]
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_van_field, {
                                  name: "derivativeDetail3",
                                  modelValue: _ctx.derivativeCode10.derivativeDetail3,
                                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.derivativeCode10.derivativeDetail3) = $event)),
                                  modelModifiers: { trim: true },
                                  placeholder: "请注明职位",
                                  rules: [{ required: true, message: '请注明职位' }]
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_van_field, {
                                    name: "derivativeDetail2",
                                    modelValue: _ctx.derivativeCode10.startDate,
                                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.derivativeCode10.startDate) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "任职开始时段",
                                    readonly: "",
                                    onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.showStartDatePicker = true)),
                                    rules: [{ required: true, message: '请输入任职时段' }]
                                  }, {
                                    "right-icon": _withCtx(() => _cache[69] || (_cache[69] = [
                                      _createElementVNode("i", { class: "iconfont icon-icon--date" }, null, -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _cache[71] || (_cache[71] = _createElementVNode("div", { class: "to" }, "~", -1)),
                                  _createVNode(_component_van_field, {
                                    name: "derivativeDetail2",
                                    modelValue: _ctx.derivativeCode10.endDate,
                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.derivativeCode10.endDate) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "任职结束时段",
                                    readonly: "",
                                    onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showEndDatePicker = true)),
                                    rules: [{ required: true, message: '请输入任职时段' }]
                                  }, {
                                    "right-icon": _withCtx(() => _cache[70] || (_cache[70] = [
                                      _createElementVNode("i", { class: "iconfont icon-icon--date" }, null, -1)
                                    ])),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_van_popup, {
                            show: _ctx.showStartDatePicker,
                            "onUpdate:show": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.showStartDatePicker) = $event)),
                            round: "",
                            position: "bottom"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_datetime_picker, {
                                type: "date",
                                title: "选择时间",
                                modelValue: _ctx.currentDate,
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.currentDate) = $event)),
                                formatter: _ctx.formatter,
                                onCancel: _cache[54] || (_cache[54] = ($event: any) => (_ctx.showStartDatePickerToggle(false))),
                                onConfirm: _ctx.onStartDateConfirm,
                                "min-date": _ctx.minDate,
                                "max-date": _ctx.currDate
                              }, null, 8, ["modelValue", "formatter", "onConfirm", "min-date", "max-date"])
                            ]),
                            _: 1
                          }, 8, ["show"]),
                          _createVNode(_component_van_popup, {
                            show: _ctx.showEndDatePicker,
                            "onUpdate:show": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.showEndDatePicker) = $event)),
                            round: "",
                            position: "bottom"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_datetime_picker, {
                                type: "date",
                                title: "选择时间",
                                modelValue: _ctx.currentDate,
                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.currentDate) = $event)),
                                formatter: _ctx.formatter,
                                onCancel: _cache[57] || (_cache[57] = ($event: any) => (_ctx.showEndDatePickerToggle(false))),
                                onConfirm: _ctx.onEndDateConfirm,
                                "min-date": _ctx.minEndDate,
                                "max-date": _ctx.currDate
                              }, null, 8, ["modelValue", "formatter", "onConfirm", "min-date", "max-date"])
                            ]),
                            _: 1
                          }, 8, ["show"]),
                          _createVNode(_component_van_checkbox, {
                            shape: "square",
                            name: 11
                          }, {
                            icon: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(`iconfont ${
                        _ctx.form.derivativeCheck.includes(11)
                          ? 'icon-duoxuanxuanzhong'
                          : 'icon-duoxuanweixuanzhong'
                      }`)
                              }, null, 2)
                            ]),
                            default: _withCtx(() => [
                              _cache[72] || (_cache[72] = _createTextVNode(" 阁下曾否在过去三年执行过五次以上任何衍生品的交易 "))
                            ]),
                            _: 1
                          }),
                          (_ctx.form.derivativeCheck.includes(11))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _cache[75] || (_cache[75] = _createElementVNode("div", { class: "tips" }, "请上传衍生品交易记录证明", -1)),
                                _createVNode(_component_van_field, {
                                  name: "uploader",
                                  rules: [{ required: true, message: '请上传衍生品交易记录证明' }]
                                }, {
                                  input: _withCtx(() => [
                                    _createVNode(_component_van_uploader, {
                                      modelValue: _ctx.fileList,
                                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.fileList) = $event)),
                                      "before-read": _ctx.beforeRead,
                                      accept: ".pdf,image/*",
                                      "max-count": "1",
                                      "preview-size": "86",
                                      onClick: _ctx.uploadToApp,
                                      readonly: _ctx.isApp,
                                      deletable: false
                                    }, {
                                      "preview-cover": _withCtx((file) => [
                                        _createElementVNode("div", {
                                          class: "preview-cover",
                                          onClick: _withModifiers(($event: any) => (_ctx.fileDel(file)), ["stop"])
                                        }, _cache[73] || (_cache[73] = [
                                          _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                                        ]), 8, _hoisted_15)
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[74] || (_cache[74] = _createElementVNode("div", { class: "upload-style" }, [
                                          _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }),
                                          _createElementVNode("p", null, "交易记录")
                                        ], -1))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "before-read", "onClick", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_popup, {
          show: _ctx.showWarrantsPop,
          "onUpdate:show": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.showWarrantsPop) = $event)),
          onClosePopup: _cache[62] || (_cache[62] = ($event: any) => (_ctx.showWarrantsPopToggle(false))),
          onClickOverlay: _cache[63] || (_cache[63] = ($event: any) => (_ctx.showWarrantsPopToggle(false))),
          title: "衍生品",
          content: '包括衍生权证、界内证、牛熊证，交易所买卖产品，结构性/复杂性/场外交易产品等',
          height: "60%"
        }, null, 8, ["show"])
      ]),
      _: 1
    }, 8, ["onHandleNext", "isDisabled", "form"]),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.fileActionState,
      "onUpdate:show": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.fileActionState) = $event)),
      actions: _ctx.actionsList,
      "cancel-text": "取消",
      "close-on-click-action": "",
      onSelect: _ctx.onFileSelect
    }, null, 8, ["show", "actions", "onSelect"])
  ], 64))
}